module.exports = __webpack_public_path__ + "img/leftTou.9b6d518f.svg";